import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"twitter\"><path d=\"M17.751 2.667h3.067l-6.7 7.624L22 20.666h-6.172l-4.833-6.292-5.531 6.292h-3.07l7.167-8.155L2 2.667h6.328l4.37 5.751 5.053-5.751Zm-1.076 16.172h1.7L7.404 4.399H5.58l11.094 14.44Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol